import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    SvgIcon,
} from '@mui/material';
import linkIcons from '../../lib/linkIcons';
import React, {ReactNode} from 'react';

type Props = {
    url: string | undefined;
    label: ReactNode;
    icon?: keyof typeof linkIcons;
};

export default function SimpleLink({url, label, icon}: Props) {
    return (
        <ListItemButton
            disabled={!url}
            component={'a'}
            href={url || '#'}
            onClick={!url ? () => false : undefined}
            target={'_blank'}
            rel={'noopener'}
        >
            <ListItemIcon>
                <SvgIcon
                    component={linkIcons[icon || 'link'].image}
                    inheritViewBox
                    color={'inherit'}
                />
            </ListItemIcon>
            <ListItemText primary={label} />
        </ListItemButton>
    );
}
